import { render, staticRenderFns } from "./Relation-ArchivesVoucher.vue?vue&type=template&id=662274cd&"
import script from "./Relation-ArchivesVoucher.vue?vue&type=script&lang=js&"
export * from "./Relation-ArchivesVoucher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports